import Bidnames from "./bidnames";

export default Bidnames;